import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import {
	ExportLeadsJobsResponse,
	Job,
	ServerDataResponse
} from '../../models/models';
import { map } from 'rxjs/operators';

@Injectable()
export class JobsDataServiceProvider {
	job2Edit: BehaviorSubject<any> = new BehaviorSubject(false);
	forceJobUpdate: BehaviorSubject<any> = new BehaviorSubject(false);

	constructor(public http: HttpClient) {}

	get jobObservable() {
		return this.job2Edit.asObservable();
	}

	get shouldJobBeUpdatedObservable() {
		return this.forceJobUpdate.asObservable();
	}

	emitJob(job) {
		return this.job2Edit.next(JSON.parse(JSON.stringify(job)));
	}

	emitForceJobUpdateEvent(value) {
		this.forceJobUpdate.next(value);
	}

	getJobInfo(id, showNewTaskId = '') {
		const url = '/protected/rest/jobs/view';
		let params = new HttpParams();
		params = params.append('id', id);
		params = params.append('showNewTaskId', showNewTaskId);
		return this.http.get(url, { params });
	}

	editJob(job) {
		const url = '/protected/rest/add_new_job/update';
		return this.http.post(url, job);
	}

	getActiveJobs() {
		const url = '/protected/rest/jobs/active';
		return this.http.get(url);
	}

	getJobOnDashboard(pageRequest) {
		const url = '/api/user/v1/job';
		return this.http.post(url, pageRequest);
	}

	getJobsOnPage(pageRequest) {
		const {
			perPage,
			page,
			pageOrder: { predicate, reverse },
			search,
			filter
		} = pageRequest;
		const url = '/api/user/jobs';

		let params = new HttpParams();
		params = params.append('perPage', perPage);
		params = params.append('page', page);
		params = params.append('predicate', predicate);
		params = params.append('reverse', reverse);
		params = params.append('search', search);
		params = params.append('filter', filter);

		return this.http.get(url, { params });
	}

	changeTaskState(jobId, task) {
		const url = `/protected/rest/jobs/${jobId}/tasks/${task.id}`;
		const body = JSON.stringify(task.completed);
		const headers = new HttpHeaders().set(
			'Content-Type',
			'application/json;charset=UTF-8'
		);

		return this.http.post(url, body, { headers });
	}

	deleteJob(jobId) {
		const url = `/api/user/v1/job/${jobId}/delete`;
		return this.http.delete(url);
	}

	acceptJobOrLead(jobId, taskCompleted) {
		const url = `/protected/rest/jobs/${jobId}/accept`;
		const body = JSON.stringify(taskCompleted);
		const headers = new HttpHeaders().set(
			'Content-Type',
			'application/json;charset=UTF-8'
		);

		return this.http.post(url, body, { headers });
	}

	searchClient(searchClient) {
		const url = '/protected/rest/job/client/search';
		let params = new HttpParams();
		params = params.append('search', searchClient);

		return this.http.get(url, { params });
	}

	getQuoteInvoiceJob(jobId: number) {
		const url = `/api/user/v1/job/${jobId}`;

		return this.http.get(url);
	}

	getJobsExport() {
		const url = '/api/user/v1/job/export/start-process';
		return this.http
			.get(url)
			.pipe(
				map(
					(
						res: ServerDataResponse<ExportLeadsJobsResponse>
					): ExportLeadsJobsResponse => res.data
				)
			);
	}

	getCPLink(url: string): Observable<object> {
		return this.http.get(url);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/job/jobs.data.service.ts